// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Dl-z","tupacHeader":"El-z","tupacHeader2":"Fl-z","tupacMenu":"Gl-z","tupacMenu2":"Hl-z","tupacMain":"Il-z","tupacMain2":"Jl-z"};